<template>
  <div class="offline-payment">
    <div class="offline-payment-instructions mx-ni px-i">
      <div class="highlighted-section">
        <div class="px-i highlighted-section-row">
          <div class="highlighted-section-row-start">
            <h2 class="highlighted-section-row-start-text">
              Offline Payment Instructions
            </h2>
          </div>
        </div>
        <div class="px-i highlighted-section-row highlighted-section-row-instructions">
          <div class="highlighted-section-row-start">
            <h3 class="highlighted-section-row-start-text">
              1. Present your Fawter or ihjoz Order Number at any of the below points of sale
            </h3>
          </div>
          <div class="highlighted-section-row-start highlighted-section-row-start-instructions">
            <div class="order-instructions-number">
              {{ tenantInvoiceNumber }}
            </div>
          </div>
        </div>
        <div class="px-i highlighted-section-row">
          <div class="highlighted-section-row-start highlighted-section-row-instructions">
            <h3 class="highlighted-section-row-start-text">
              2. Settle your order and get your receipt
            </h3>
            <div class="highlighted-section-row-start-list">
              Your receipt tickets will be<br>
              - Sent by email and/or SMS<br>
              - Always accessible online<br>
              - Printed at points of sale (optional)
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="offline-payment-continue offline-payment-continue-borderless flex-column mx-ni px-i pb-0">
      <div class="offline-payment-continue-notice px-i">
        <p>By paying the invoice you acknowledge that you agree to the Terms & Conditions of Fawter and the Invoice.</p>
        <p>*Prices are VAT inclusive</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfflinePaymentInstructions",

  props: {
    paymentFees: { type: Object },
    tenantInvoiceNumber: { type: String },
    currencyIsoCode: { type: String },
    invoiceTotal: { type: Number },
    paymentMethodId: { type: Number },
    passOnFawterFee: { type: Boolean }
  },

  computed: {
    paymentMethodPaymentFees () {
      return this.paymentFees[this.paymentMethodId];
    },

    currencyMinimumDigits () {
      return  (this.currencyIsoCode === "LBP") ? 0 : 2;
    },
  }
}
</script>

